import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NavigationItem = ({ icon, label, active, href }) => {
  return (
    <S.Container $active={active} to={href}>
      <S.Item $active={active}>
        <S.Icon>{icon}</S.Icon>
        <S.Label>{label}</S.Label>
      </S.Item>
    </S.Container>
  );
};

const S = {
  Container: styled(Link)`
    position: relative;
    padding: 0 1rem 0 1.75rem;
    cursor: pointer;
    margin-bottom: 0.5rem;
    text-decoration: none;
    display: block;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 5px;
      height: 100%;
      background: ${({ theme, $active }) =>
        $active ? theme.colors.primary : ''};
      border-radius: 0 6px 6px 0;
    }
  `,
  Item: styled.div`
    display: flex;
    align-items: center;
    padding: 1.25rem 1.5rem;
    border-radius: ${({ theme }) => theme.borderRadius};
    font-size: 0.9rem;
    letter-spacing: 0.3px;
    background: ${({ theme, $active }) =>
      $active ? theme.colors.primary : '#fff'};

    color: ${({ theme, $active }) =>
      $active ? theme.colors.primaryText : theme.colors.bodyText};

    &:hover {
      background: ${({ theme, $active }) =>
        $active ? theme.colors.primary : theme.colors.body};
    }
  `,
  Icon: styled.span`
    margin-right: 1rem;
  `,
  Label: styled.span`
    line-height: 1;
    text-decoration: none;
  `,
};

export default NavigationItem;
